import NRSummaryDonut from './NRSummaryDonut';
import CircularProgress from '@mui/material/CircularProgress';
import { isEmpty } from '../../../utils/utils';
import { useEffect, useState } from 'react';
import { CONSTANTS } from '../../../constants/constants';
import { VULNS_SUMMARY_COUNT } from '../../../graphql/queries/analytics';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useNRLazyQuery from '../../../graphql/useNRLazyQuery';
import { encodeParam } from '../../../services/params.utils';
import { removeTabAndSubTabFromFilePath } from '../../../services/urlInterceptor.utils';

const severities = ['low', 'medium', 'high', 'critical'];

function NRSummaryDonutContainer({ summaryData, isPrintView = false }) {
  // const { showUnremediated } = useContext(RemediationContext);
  const [redirectToParams, setRedirectToParams] = useState();
  const { componentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    !!redirectToParams &&
      navigate(`${removeTabAndSubTabFromFilePath(location)}${'/' + CONSTANTS.REPORT.TABS.VULNERABILITIES}?${redirectToParams.toString()}`);
  }, [redirectToParams]);

  const dataPointSelection = (event, chartContext, config) => {
    let extraParams = new URLSearchParams();
    extraParams.append('vulnerabilitySeverityFilter', encodeParam([severities[config.dataPointIndex]?.toUpperCase()]));
    setRedirectToParams(extraParams);
  };

  const [data, isLoading, isCalled, makeRequest] = useNRLazyQuery({
    query: VULNS_SUMMARY_COUNT,
    options: {
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          composedAssetId: componentId
          // , showUnremediated
        }
      },
      context: { version: 'v3' }
    },
    qlObjKey: 'analytics',
    transformData: resp => {
      if (resp && resp.vulnerabilitiesSummaryCount) {
        const { __typename, ...filteredObj } = resp.vulnerabilitiesSummaryCount;
        return filteredObj;
      }
    }
  });

  useEffect(() => {
    if (summaryData || !componentId) {
      return;
    }
    makeRequest({
      variables: {
        args: {
          composedAssetId: componentId
          // , showUnremediated
        }
      }
    });
  }, [
    // showUnremediated,
    componentId,
    summaryData,
    makeRequest
  ]);

  const effectiveData = summaryData || data;
  const shouldShowDonut = !!effectiveData && !isEmpty(effectiveData) && (!!summaryData || !!isCalled);

  return (
    <>
      {!summaryData && isLoading && <CircularProgress color={'primary'} style={{ marginLeft: 'auto', marginRight: 'auto' }} />}
      {!isLoading && shouldShowDonut && (
        <NRSummaryDonut
          low={effectiveData.low}
          medium={effectiveData.medium}
          high={effectiveData.high}
          critical={effectiveData.critical}
          dataPointSelection={isPrintView ? undefined : dataPointSelection}
          isPrintView={isPrintView}
        />
      )}
      {!effectiveData && !isLoading && <span>No info to show</span>}
    </>
  );
}

export default NRSummaryDonutContainer;
